import React, { Fragment } from 'react';

import Divider from 'components/divider/divider';

import Skeleton from 'components/skeleton/skeleton';

import KanbanCardSkeleton from '../kanban-card/kanban-card-skeleton';

const NUMBER_OF_COLUMNS = 5;
const COLUMNS_SIZE = [4, 8, 5, 7, 9];

const PlannerTableSkeleton: React.FC = () => {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-5 mb-4 w-full">
        {[...Array.from({ length: 5 }, (x, i) => i)].map((key: number) => (
          <div className="col-span-1" key={key}>
            <Skeleton className="w-24 h-10" />
            <div className="flex flex-col lg:flex-row mt-4">
              <div className="flex flex-col flex-1 p-3 lg:p-0 mb-4 lg:mb-auto lg:bg-inherit border border-solid border-gray-200 rounded-md lg:rounded-none lg:border-none">
                {[
                  ...Array.from({ length: COLUMNS_SIZE[key] }, (x, i) => i),
                ].map((ind: number) => (
                  <KanbanCardSkeleton key={ind} className="mb-4" />
                ))}
              </div>
              {key + 1 !== NUMBER_OF_COLUMNS && (
                <>
                  <Divider
                    orientation="vertical"
                    className="mx-2 hidden lg:block"
                  />
                  <Divider
                    orientation="horizontal"
                    className="my-2 block lg:hidden"
                  />
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default PlannerTableSkeleton;
